export const ONBOARDING_STATE_PREFIX = 'onboarding-state:';
export const PEOPLE = 'peopleNudge';
export const LEGACY = 'legacy';
export const INTRO_WORKFLOW = 'introWorkflow';
export const FIRST_SPACE_SELECTED = 'firstSpaceSelected';
export const TEAM_SPACE_CREATED = 'teamSpaceCreated';
export const XFLOW_SPACE_CREATED = 'xflowSpaceCreated';

// Nth User Getting Started experiment
// NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP is also used for the Auto Page Emoji Experiment
export const NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP = 'nthUserOnboardingCompletedTimestamp';
export const NTH_USER_ONBOARDING_FLAG_VIEWED = 'nthUserOnboardingFlagViewed';
export const NTH_USER_ONBOARDING_PAGE_VIEWED = 'nthUserOnboardingPageViewed';
export const IMPROVED_GET_STARTED_NTH_USER_PATH = 'nthUserGSPagePath';
export const NTH_USER_BANNER_DISMISSED = 'nthUserBannerDismissed';

export const HELP = 'help';
export const ONBOARDING_INTENTS = 'onboardingIntents';
export const IS_FOUNDING_ADMIN = 'isFoundingAdmin';
export const IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE = 'isSampleContentV2SpotlightVisible';
export const IS_MORE_ACTIONS_TOUR_VISIBLE = 'isMoreActionsTourVisible';
export const IS_MORE_ACTIONS_HINT_VISIBLE = 'isMoreActionsHintVisible';
export const LAND_ON_PATH = 'landOnPath';
export const TEMPLATE_ONBOARDING_VIEWED_TIME = 'templateOnboardingViewedTime';
export const ONBOARDING_INTENT_EXPERIENCES = {
	ONBOARDING_INTENT_EXPERIENCES_CLOSED:
		'onboarding-intent-experiences:onboardingIntentExperienceClosed',
	ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
	ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT:
		'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
	ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED:
		'onboarding-intent-experiences:onboardingIntentExperienceLandClosed',
} as const;

export const ONBOARDING_REVERSE_TRIAL = {
	MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen',
} as const;

export const TEMPLATES_COLLECTION = {
	EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
	EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed',
} as const;

export const SPACE_GETTING_STARTED_TOUR_EXPERIENCES = {
	IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed',
} as const;

export const PERSISTENT_INVITE = {
	HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities',
} as const;

export const IMPROVED_GET_STARTED_PATH = 'improvedGetStartedPath';
export const IMPROVED_GET_STARTED_WHITEBOARD_PATH = 'improvedGetStartedWhiteboardPath';

export const IS_REDACTIONS_TOUR_VISIBLE = 'isRedactionsTourVisible';

export const IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED = 'nav4:isNav4GlobalSpotlightDismissed';
export const IS_NAV_4_SPACE_TOUR_DISMISSED = 'nav4:isNav4SpaceTourDismissed';
export const IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED =
	'nav4:isNav4CollapseReminderSpotlightDismissed';

export const CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT =
	'creation-focused-nav:shouldShowSpotlight' as const;
export const CREATION_FOCUSED_NAV_START_TIME = 'creation-focused-nav:startTime' as const;

export const CONTENT_TREE_BULK_ACTIONS = {
	BULK_ACTIONS_CHANGEBOARDING_SPOTLIGHT_DISMISSED:
		'content-tree-bulk-actions:isBulkActionsChangeboardingSpotlightDismissed',
} as const;

export const WHATS_NEW_IN_CONFLUENCE = {
	IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
	PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt',
} as const;

export const MODERNIZE_CONFLUENCE_IPM_MODAL = {
	HAS_DISMISSED_MODAL: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
	HAS_DISMISSED_BANNER: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner',
} as const;

export const CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH = {
	HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal',
} as const;

export const NTH_USER_SETUP_CONTENT_TYPE = {
	NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
	NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
	NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND:
		'nth-user-setup:nthUserContentTypePopularContentFound',
	NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId',
} as const;

export const PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED = {
	PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed',
} as const;

export const PROMPT_DATABASE_COMPETITOR_LINK = {
	DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed',
} as const;

export const NTH_USER_AUTO_FOLLOW_SPACES = {
	HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces', // favorited
	HAS_AUTO_FOLLOWED_SPACES_V2: 'nth-user-auto-follow-spaces:hasAutoFollowedSpacesV2', // favorited AND followed
} as const;

export const NTH_USER_AUTO_FOLLOW_TEAMMATES = {
	HAS_AUTO_FOLLOWED_TEAMMATES: 'nth-user-auto-follow-teammates:hasAutoFollowedTeammates',
	AUTO_FOLLOW_BANNER_DISMISSED: 'nth-user-auto-follow-teammates:autoFollowBannerDismissed',
	AUTO_FOLLOW_BANNER_SHOWN_AT: 'nth-user-auto-follow-teammates:autoFollowBannerShownAt',
} as const;

export const LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA = {
	REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt',
} as const;

export const USE_CASES_NTH_USER_ONBOARDING = {
	SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
	VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
	DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
	VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt',
} as const;

export const NTH_USER_EMOJI_TITLE_DISCOVERED = {
	EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered',
} as const;

// existing onboarding experiences for making query calls
export const ONBOARDING_EXPERIENCES = {
	INTRO_WORKFLOW: `${ONBOARDING_STATE_PREFIX}${INTRO_WORKFLOW}`,
	LEGACY_ONBOARDING_STATE: `${ONBOARDING_STATE_PREFIX}${LEGACY}`,
	IS_FOUNDING_ADMIN: `${ONBOARDING_STATE_PREFIX}${IS_FOUNDING_ADMIN}`,
	IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${ONBOARDING_STATE_PREFIX}${IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE}`,
	LAND_ON_PATH: `${ONBOARDING_STATE_PREFIX}${LAND_ON_PATH}`,
	TEAM_SPACE_CREATED: `${ONBOARDING_STATE_PREFIX}${TEAM_SPACE_CREATED}`,
	IS_MORE_ACTIONS_TOUR_VISIBLE: `${ONBOARDING_STATE_PREFIX}${IS_MORE_ACTIONS_TOUR_VISIBLE}`,
	IS_MORE_ACTIONS_HINT_VISIBLE: `${ONBOARDING_STATE_PREFIX}${IS_MORE_ACTIONS_HINT_VISIBLE}`,
	IMPROVED_GET_STARTED_PATH: `${ONBOARDING_STATE_PREFIX}${IMPROVED_GET_STARTED_PATH}`,
	IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${ONBOARDING_STATE_PREFIX}${IMPROVED_GET_STARTED_WHITEBOARD_PATH}`,
	IMPROVED_GET_STARTED_NTH_USER_PATH: `${ONBOARDING_STATE_PREFIX}${IMPROVED_GET_STARTED_NTH_USER_PATH}`,
	IS_REDACTIONS_TOUR_VISIBLE: `${ONBOARDING_STATE_PREFIX}${IS_REDACTIONS_TOUR_VISIBLE}`,
	XFLOW_SPACE_CREATED: `${ONBOARDING_STATE_PREFIX}${XFLOW_SPACE_CREATED}`,
	TEMPLATE_ONBOARDING_VIEWED_TIME: `${ONBOARDING_STATE_PREFIX}${TEMPLATE_ONBOARDING_VIEWED_TIME}`,
	NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${ONBOARDING_STATE_PREFIX}${NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP}`,
	NTH_USER_ONBOARDING_FLAG_VIEWED: `${ONBOARDING_STATE_PREFIX}${NTH_USER_ONBOARDING_FLAG_VIEWED}`,
	NTH_USER_ONBOARDING_PAGE_VIEWED: `${ONBOARDING_STATE_PREFIX}${NTH_USER_ONBOARDING_PAGE_VIEWED}`,
	NTH_USER_BANNER_DISMISSED: `${ONBOARDING_STATE_PREFIX}${NTH_USER_BANNER_DISMISSED}`,
} as const;

// existing experience status
export const COMPLETE = '__complete__';

export const { LEGACY_ONBOARDING_STATE } = ONBOARDING_EXPERIENCES;

export const OnboardingKeys = [
	...Object.values(ONBOARDING_INTENT_EXPERIENCES),
	...Object.values(ONBOARDING_REVERSE_TRIAL),
	...Object.values(TEMPLATES_COLLECTION),
	...Object.values(SPACE_GETTING_STARTED_TOUR_EXPERIENCES),
	...Object.values(PERSISTENT_INVITE),
	IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED,
	IS_NAV_4_SPACE_TOUR_DISMISSED,
	IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED,
	CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT,
	CREATION_FOCUSED_NAV_START_TIME,
	...Object.values(WHATS_NEW_IN_CONFLUENCE),
	...Object.values(MODERNIZE_CONFLUENCE_IPM_MODAL),
	...Object.values(CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH),
	...Object.values(NTH_USER_SETUP_CONTENT_TYPE),
	...Object.values(PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED),
	...Object.values(PROMPT_DATABASE_COMPETITOR_LINK),
	...Object.values(ONBOARDING_EXPERIENCES),
	...Object.values(CONTENT_TREE_BULK_ACTIONS),
	...Object.values(NTH_USER_AUTO_FOLLOW_SPACES),
	...Object.values(NTH_USER_AUTO_FOLLOW_TEAMMATES),
	...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA),
	...Object.values(USE_CASES_NTH_USER_ONBOARDING),
	...Object.values(NTH_USER_EMOJI_TITLE_DISCOVERED),
] as const;
